import feedImage from '../assets/nextcastle-feed.png';
import detailedEngineeringImage from '../assets/nextcastle-engineering -design.png';
import processEngineeringImage from '../assets/nextcastle-process-design.png';
import structuralCivilImage from '../assets/nextcastle-civil-engineering.png';
import pipingPipelineImage from '../assets/nextcastle-piping.png';
import electricalInstrumentationImage from '../assets/nextcastle-electrical.png';
import mechanicalEngineeringImage from '../assets/nextcastle-mechanical.png';
import automationControlImage from '../assets/nextcastle-automation.png';


const engineeringCapabilities = [
  {
    id: 1,
    title: "Front-End Engineering & Design (FEED)",
    description:
    "We conduct comprehensive feasibility studies, process simulations, and risk assessments to establish cost-effective and efficient engineering solutions. Our FEED services optimize project execution, minimizing risks and ensuring regulatory compliance.",
    picture: feedImage,
  },
  {
    id: 2,
    title: "Detailed Engineering & Design",
    description:
    "Our team of highly skilled engineers provides precise design solutions for offshore and onshore facilities. We handle structural, mechanical, electrical, instrumentation, and piping designs that align with industry standards and client specifications.",
    picture: detailedEngineeringImage,
  },
  {
    id: 3,
    title: "Process Engineering",
    description:
    "We specialize in developing and optimizing process systems, ensuring efficiency, safety, and environmental compliance. Our process engineering services include flow assurance, separation systems, and heat transfer optimization.",
    picture: processEngineeringImage,
  },
  {
    id: 4,
    title: "Structural & Civil Engineering",
    description:
    "Our expertise covers structural analysis, foundation design, and civil engineering for oil and gas infrastructure. We ensure durability, safety, and compliance with international standards for all engineered structures.",
    picture: structuralCivilImage,
  },
  {
    id: 5,
    title: "Piping & Pipeline Engineering",
    description:
    "We provide innovative pipeline and piping solutions, including routing, stress analysis, and material selection. Our designs ensure pipeline integrity, operational efficiency, and longevity in extreme environments.",
    picture: pipingPipelineImage,
  },
  {
    id: 6,
    title: "Electrical & Instrumentation Engineering",
    description:
    "From power distribution to automated control systems, we design and integrate electrical and instrumentation solutions for oil and gas facilities. Our expertise ensures seamless operations, safety, and energy efficiency.",
    picture: electricalInstrumentationImage,
  },
  {
    id: 7,
    title: "Mechanical Engineering & Equipment Design",
    description:
    "We deliver customized mechanical engineering solutions, including pressure vessel design, rotating equipment selection, and material specification, ensuring reliability and efficiency in operations.",
    picture: mechanicalEngineeringImage,
  },
  {
    id: 8,
    title: "Automation & Control Systems",
    description:
    "Our automation solutions enhance operational efficiency and safety. We design and integrate SCADA, DCS, and PLC systems to enable remote monitoring, control, and data analysis for oil and gas facilities.",
    picture: automationControlImage,
  },
  ];

  
  export default engineeringCapabilities;
  